import type {UserSessionState} from "./UserSessionState";
import {getFullNameOrEmpty} from "../utils/userHelper";
import {loadScript} from "../utils/script";


export const initSupportChat = async (currentLocale: string, userState: UserSessionState) => {
    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_API.autoStart = true;
    window.Tawk_API.visitor = {
        name: getFullNameOrEmpty(userState.currentUserDb!),
        email: userState.currentUserDb?.email!,
    };
    window.Tawk_LoadStart = new Date();

    const notifyEndpoint = (() => {
        const base = import.meta.env.VITE_APP_PM_SERVER_ENDPOINT;
        if (!base) return null;
        try {
            const url = new URL(base);
            url.pathname = '/chat/notify';
            return url.toString();
        } catch {
            return null;
        }
    })();

    if (notifyEndpoint) {
        const visitorName = getFullNameOrEmpty(userState.currentUserDb!) || undefined;
        const email = userState.currentUserDb?.email || undefined;

        const notify = (event: string, extra?: Record<string, unknown>) => {
            fetch(notifyEndpoint, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({event, source: 'app', visitorName, email, page: window.location.href, ...extra}),
                keepalive: true,
            }).catch(() => {});
        };

        let started = false;
        window.Tawk_API.onChatStarted = () => {
            if (started) return;
            started = true;
            notify('chat_started');
        };
        window.Tawk_API.onChatMessageVisitor = (message) => {
            notify('visitor_message', {message});
        };
    }

    const embedUrl = currentLocale === "ru-RU"
        ? import.meta.env.VITE_APP_TWAK_EMBED_RU
        : import.meta.env.VITE_APP_TWAK_EMBED;
    if (embedUrl) {
        await loadScript(embedUrl);
    }
}
